module.exports = __webpack_public_path__ + "static/media/bolinhacalabresa.7ea8f1b3.webp";